<template>
  <div>
    <v-card>
    <v-card-title>
      ML Hardware and Software Resources (Total: {{filteredhardsoftwareitems.length}})
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        prepend-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        class="mb-5"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-select v-model="grouping" prepend-icon="mdi-sort" label="Group by" :items=groupingOptions></v-select>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="1000px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              color="primary"
            ><v-icon light>mdi-plus</v-icon>Add a new ML Hard- and Software Resource</v-btn>
          </template>
          <v-card>
            <v-card-title style="background-color:#2DC6D6">
              <span class="headline" style="color:#FFFFFF">{{ formTitle }}</span>
            </v-card-title>
            <v-img
              height="200"
              src="https://shrm-res.cloudinary.com/image/upload/c_crop,h_1081,w_2520,x_20,y_0/w_auto:100,w_2100,h_900,q_auto,f_auto/v1/Competencies/17-1049_Long_Forum_Artwork_v2-02_uz67zd"
            ><div class="fill-height bottom-gradient"></div></v-img>
             <v-card-title style="color:#2DC6D6"><v-icon color="primary" class="mx-1">mdi-account-circle</v-icon>Personal Information
               (<v-switch
                  v-model="rememberUserInfo"
                  :label="`Remember: ${rememberUserInfo.toString()}`"
                  class="mx-2"
                ></v-switch>)
             </v-card-title>
            <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.name" label="Full Name" type="text" autocomplete="username"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.email" label="E-Mail" type="text" autocomplete="email"></v-text-field>
                  </v-col>
                    <v-col cols="12" sm="6" md="4">
                       <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                          <v-combobox
                        v-model="editedItem.status"
                        :items="status"
                        clearable
                        label="Status"
                         v-bind="attrs"
                          v-on="on"
                      >
                        <template v-slot:selection="{ item, parent }">
                          <v-chip close @click:close="parent.selectItem(item)">
                            <span class="chip-label">{{ item }}</span>
                          </v-chip>
                        </template>
                      </v-combobox>
                      </template>
                      <span>Current status at TUHH (e.g. PhD candidate)</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                          <v-combobox
                        v-model="editedItem.institute"
                        :items="institutes"
                        clearable
                        label="Institute / Organisation"
                        placeholder="e.g. M-18"
                         v-bind="attrs"
                          v-on="on"
                      >
                        <template v-slot:selection="{ item, parent }">
                          <v-chip close @click:close="parent.selectItem(item)">
                            <span class="chip-label">{{ item }}</span>
                          </v-chip>
                        </template>
                      </v-combobox>
                      </template>
                        <span>Institute or organization owning the ressource</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                    v-model="editedItem.instituteWebsite"
                    label="(Institute) Homepage"
                    placeholder="https://"
                    :rules="[rules.urlrule]"
                    :append-icon="editedItem.instituteWebsite != undefined ? (editedItem.instituteWebsite.includes('http') ? 'mdi-open-in-new' : ''):''"
                    @click:append="openLink(editedItem.instituteWebsite)"
                     v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <span>Please provide a link to a homepage / personal page that will allow others to get in contact!</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                </v-card-text>
                <v-divider class="mx-4"></v-divider>
                <v-card-title style="color:#2DC6D6"><v-icon color="primary" class="mx-1">mdi-account-group</v-icon> ML Hard-/Software Resource Information</v-card-title>
                <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                     <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                    <v-combobox
                      v-model="editedItem.hardwareType"
                      :items="hardwareTypes"
                      label="Hardware Type"
                      chips
                      deletable-chips
                      clearable
                      multiple
                      v-bind="attrs"
                          v-on="on"
                    >
                      <template v-slot:selection="{ item, parent }">
                        <v-chip close @click:close="parent.selectItem(item)">
                          <span class="chip-label">{{ item }}</span>
                        </v-chip>
                      </template>
                    </v-combobox>
                    </template>
                      <span>Which Type/Category does the Hardware fit in? (e.g. HPC-Cluster, Workstation)?</span>
                    </v-tooltip>
                  </v-col>
                   <v-col cols="12" sm="6" md="4">
                     <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                         <v-text-field v-model="editedItem.description" label="Description" v-bind="attrs"
                          v-on="on"></v-text-field>
                    </template>
                      <span>Hardware Specifications and additional information (e.g. Linux Pool, Cluster Nodes, GPUs, CPUs, etc.)</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                    <v-combobox
                      v-model="editedItem.installedMLlibsFrameworks"
                      :items="mlLibraries"
                      label="Installed ML Libraries / Frameworks etc. (multiple)"
                      multiple
                      chips
                      deletable-chips
                      clearable
                      v-bind="attrs"
                          v-on="on"
                    >
                      <template v-slot:selection="{ item, parent }">
                        <v-chip close @click:close="parent.selectItem(item)">
                          <span class="chip-label">{{ item }}</span>
                        </v-chip>
                      </template>
                    </v-combobox>
                    </template>
                      <span>Which Libraries / Frameworks etc. are installed in the machine (optionally include Versions)?</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                     <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                         <v-text-field v-model="editedItem.location" label="Location" v-bind="attrs"
                          v-on="on"  :append-icon="editedItem.location != undefined ? (editedItem.location.includes('http') ? 'mdi-open-in-new' : ''):''"
                          @click:append="editedItem.location != undefined ? editedItem.location.includes('http') ? openLink(editedItem.location) : null : null"
                    ></v-text-field>

                    </template>
                      <span>Where is the hardware resource located at / how can it be accesed?</span>
                    </v-tooltip>
                  </v-col>
                   <v-col cols="12" sm="6" md="4">
                       <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                          <v-select
                        v-model="editedItem.shareable"
                        :items="shareableValues"
                        label="Shareable on Request"
                         v-bind="attrs"
                          v-on="on"
                      ></v-select>
                      </template>
                      <span>Can the resource be shared with others on request?</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
            </v-card-text>

              <v-card-title><v-icon color="warning" class="mx-1">mdi-lock</v-icon> Password for Editing (<v-icon small>mdi-shield-key</v-icon> Encrypted)</v-card-title>
                <v-card-text>
                     <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="editedItem.token"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, rules.min, rules.matches1]"
                        :type="show1 ? 'text' : 'password'"
                        counter
                        @click:append="show1 = !show1"
                        :label="editedIndex<0 ? 'Password for editing/deleting entry *':'Password to edit this entry *'"
                        :placeholder="editedIndex<0 ? 'Specify Password' : 'Enter Password'"
                        v-bind="attrs"
                        v-on="on"></v-text-field>
                    </template>
                      <span v-if="editedIndex<0">Please specify a password to later edit and delete this entry. The password is stored encrypted. A password generator is recommended.</span>
                       <span v-else>Please enter the password to edit this entry.</span>
                    </v-tooltip>
                                        <v-tooltip top >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="confirmationToken"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, rules.min, rules.matches2]"
                        :type="show1 ? 'text' : 'password'"
                        counter
                        @click:append="show1 = !show1"
                        :label="editedIndex<0 ? 'Confirm Password for editing/deleting entry *':'Confirm Password to edit this entry *'"
                        :placeholder="editedIndex<0 ? 'Confirm specified Password' : 'Enter Password'"
                        v-show="editedIndex<0"
                        v-bind="attrs"
                        v-on="on">
                      </v-text-field>
                    </template>
                      <span v-if="editedIndex<0">Please confirm the specified password to later edit and delete this entry.</span>
                       <span v-else>Please confirm the chosen password to edit this entry.</span>
                    </v-tooltip>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" depressed @click="close">Cancel</v-btn>
              <v-btn color="accent" :disabled="editedItem.token === undefined ? true : (editedItem.token == '' ? true : ((editedItem.token.length<8) ? true : ((this.editedIndex < 0) ? ((editedItem.token !== confirmationToken) ? true : false) : false)))" depressed @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="filteredhardsoftwareitems"
      :search="search"
      :group-by=grouping
      light
    >
    <template v-for="h in headers" v-slot:[`header.${h.value}`]="{ header }">
      <v-tooltip bottom v-bind:key=h.index>
        <template v-slot:activator="{ on }">
          <span v-on="on">{{h.text}}</span>
        </template>
        <span>{{h.tooltip}}</span>
      </v-tooltip>
    </template>
    <template v-slot:item.description="{ item }">
          <div :inner-html.prop="item.description | highlight(search)">{{item.description}}</div>
    </template>
    <template v-slot:item.instituteWebsite="{ item }">
        <a v-bind:href="getLink(item.instituteWebsite)" target="_blank" ><v-icon v-if="item.instituteWebsite != undefined ? item.instituteWebsite.includes('http') : false" class="mx-1">mdi-open-in-new</v-icon> <div :inner-html.prop="item.instituteWebsite | highlight(search)">
          {{item.instituteWebsite}}</div></a>
    </template>
    <template v-slot:item.email="{ item }">
        <a v-bind:href="'mailto:'+item.email"><v-icon v-if="item.email != undefined ? item.email.includes('@') : false" class="mx-1">mdi-email-edit</v-icon> {{item.email}}</a>
    </template>
    <template v-slot:item.hardwareType="{ item }">
        <v-chip v-for="hardwareType in item.hardwareType" class="ma-1" v-bind:key="hardwareType">
          <div :inner-html.prop="hardwareType | highlight(search)">
            {{hardwareType}}</div></v-chip>
    </template>
    <template v-slot:item.installedMLlibsFrameworks="{ item }">
        <v-chip v-for="mlLibrary in item.installedMLlibsFrameworks" class="ma-1" v-bind:key="mlLibrary">
          <div :inner-html.prop="mlLibrary | highlight(search)">
            {{mlLibrary}}</div></v-chip>
    </template>
    <template v-slot:item.shareable="{ item }">
        <v-chip v-if="item.shareable==='Yes'"><v-icon color="green">check</v-icon>Yes</v-chip>
        <v-chip v-else-if="item.shareable==='No'"><v-icon  color="red">close</v-icon>No</v-chip>
        <v-chip v-else><v-icon color="green">check</v-icon>Per Default</v-chip>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
                        <v-dialog
                                v-model="deletedialog[item._id]"
                                width="500"
                                :retain-focus="false"
                        >
                            <template v-slot:activator="{ on, attrs  }">
                                <v-icon
                                small
                                v-on="on"
                                v-bind="attrs"
                              >
                                mdi-delete
                              </v-icon>
                            </template>
                            <v-card>
                                <v-card-title
                                        class="headline dark primary"
                                        primary-title
                                >
                                    Delete Hard-/Software Resource Entry
                                </v-card-title>

                                <v-card-title><v-icon color="warning" class="mx-1">mdi-lock</v-icon> Password for Deleting</v-card-title>
                                  <v-card-text>
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-text-field v-model="item.token"
                                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                          :rules="[rules.required, rules.min]"
                                          :type="show1 ? 'text' : 'password'"
                                          counter
                                          @click:append="show1 = !show1"
                                          :label="editedIndex<0 ? 'Password for editing/deleting entry *':'Password to edit this entry *'"
                                          :placeholder="editedIndex<0 ? 'Enter Password' : 'Enter Password'"
                                          v-bind="attrs"
                                          v-on="on"></v-text-field>
                                      </template>
                                        <span v-if="editedIndex<0">Please specify a password to later edit and delete this entry.</span>
                                        <span v-else>Please enter the password to edit this entry.</span>
                                      </v-tooltip>
                              </v-card-text>

                                <v-divider></v-divider>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                            color="accent" text
                                            @click="deletedialog[item._id] = false"
                                    >
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                            color="accent" text
                                            :disabled="item.token === undefined ? true : (item.token == '' ? true : (item.token.length<8) ? true : false)"
                                            @click="deletedialog[item._id] = false, deleteHard_Software(item._id, item.token)"
                                    >
                                        Delete
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
          </template>
    </v-data-table>
      </v-card>
  </div>
</template>

<script>
import DefaultsService from '@/services/defaultsService'
import HWSWService from '@/services/hard_softwareService'
import _ from 'underscore'

export default {
  data () {
    return {
      search: '',
      snack: false,
      snackColor: '',
      snackText: '',
      rememberUserInfo: false,
      rememberedname: '',
      rememberedinstitute: '',
      rememberedinstituteWebsite: '',
      rememberedstatus: '',
      max300chars: v => v.length <= 300 || 'Input too long!',
      pagination: {},
      grouping: null,
      groupingOptions: [
        { text: 'None', value: null },
        { text: 'Institute / Organisation', value: 'institute' },
        { text: 'Status', value: 'status' },
        { text: 'Hardware Type', value: 'hardwareType' },
        { text: 'Shareable on Request?', value: 'shareable' }
      ],
      headers: [
        {
          text: 'Name',
          align: 'start',
          value: 'name',
          tooltip: 'Contact person for the hardware / software ressource'
        },
        {
          text: 'Contact',
          value: 'email',
          tooltip: 'E-Mail contact of the hardware / software ressource'
        },
        { text: 'Institute / Organisation', value: 'institute', tooltip: 'Institute or organization owning the ressource' },
        { text: '(Institute) Homepage', value: 'instituteWebsite', tooltip: 'Website of the institute or organization owning the ressource' },
        { text: 'Status', value: 'status', tooltip: 'Status of the contact person for the ressource' },
        { text: 'Hardware Type', value: 'hardwareType', tooltip: 'Type/Category this ressource fits in' },
        { text: 'Description (Components / Specifications)', value: 'description', tooltip: 'Hardware Specifications and additional information (e.g. Linux Pool, Cluster Nodes, GPUs, CPUs, etc.)' },
        { text: 'Installed ML Libraries and Frameworks etc.', value: 'installedMLlibsFrameworks', tooltip: 'Libraries / Frameworks etc. installed on the ressource' },
        { text: 'Location', value: 'location', tooltip: 'Where is the hardware resource located at / how can it be accessed?' },
        { text: 'Shareable on Request?', value: 'shareable', tooltip: 'Can the resource be shared with others on request?' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      hardsoftwareitems: [
      ],
      editedIndex: -1,
      editedItem: {
      },
      confirmationToken: '',
      defaultItem: {
        name: '',
        email: '',
        institute: '',
        status: '',
        instituteWebsite: '',
        hardwareType: '',
        installedMLlibsFrameworks: [],
        location: '',
        shareable: 'No',
        token: ''
      },
      defaults: [],
      show1: false,
      rules: {
        required: value => !!value || 'Required.',
        matches1: value => (this.editedIndex < 0) ? (this.confirmationToken === value || 'Passwords need to match.') : true,
        matches2: value => this.editedItem.token === value || 'Passwords need to match.',
        min: v => v !== undefined ? (v.length >= 8 || 'Min 8 characters') : false,
        urlrule: value => (value.includes('http://') || value.includes('https://')) || 'Specify full url (incl. http:// or https://)'
      },
      deletedialog: {},
      dialog: false,
      shareableValues: ['Yes', 'No', 'Per Default']
    }
  },
  computed: {

    filteredhardsoftwareitems () {
      return _.filter(this.hardsoftwareitems, function (hardsoftwareitem) {
        return hardsoftwareitem.default === false
      })
    },
    formTitle () {
      return this.editedIndex === -1 ? 'Add New Hard- and Software Resource' : 'Edit Hard- and Software Resource'
    },
    status () {
      let status = _.union(_.map(this.hardsoftwareitems, (c) => c.status), this.defaults[0].status)
      return status
    },
    institutes () {
      let institutes = _.union(_.map(this.hardsoftwareitems, (c) => c.institute), this.defaults[0].institutes)
      return institutes
    },
    mlLibraries () {
      let mlLibs = _.map(this.hardsoftwareitems, (c) => c.installedMLlibsFrameworks)
      return _.flatten(mlLibs, 1).sort()
    },
    hardwareTypes () {
      let hwTypes = _.map(this.hardsoftwareitems, (c) => c.hardwareType)
      console.log(_.uniq((_.flatten(hwTypes, 1)).sort(), true))
      return _.uniq((_.flatten(hwTypes, 1)).sort(), true)
    }
  },
  watch: {
    dialog (val) {
      if (this.rememberUserInfo) {
        this.editedItem.name = this.editedItem.name === '' ? this.rememberedname : this.editedItem.name
        this.editedItem.email = this.editedItem.email === '' ? this.rememberedemail : this.editedItem.email
        this.editedItem.institute = this.editedItem.institute === '' ? this.rememberedinstitute : this.editedItem.institute
        this.editedItem.instituteWebsite = this.editedItem.instituteWebsite === '' ? this.rememberedinstituteWebsite : this.editedItem.instituteWebsite
        this.editedItem.status = this.editedItem.status === '' ? this.rememberedstatus : this.editedItem.status
      }
      val || this.close()
    },
    async confirmationToken () {
      await this.$nextTick()
      this.$refs.form.validate()
    },
    async editedItem () {
      await this.$nextTick()
      this.$refs.form.validate()
    }
  },

  filters: {
    highlight: function (value, query) {
      if (value !== undefined) {
        return value.replace(new RegExp(query, 'ig'), '<span class=\'primary\'>' + query + '</span>')
      } else {
        return value
      }
    }
  },

  methods: {
    async getDefaults () {
      const response = await DefaultsService.defaults()
      this.defaults = response.data.defaults
    },
    async getHard_Software () {
      const response = await HWSWService.fetchHard_Software()
      this.hardsoftwareitems = response.data.Hard_Software
    },
    async deleteHard_Software (_id_, _token_) {
      await HWSWService.deleteHard_Software({
        id: _id_,
        token: _token_
      })
      await this.getHard_Software()
    },
    async addHard_Software (comp) {
      await HWSWService.addHard_Software(comp)
    },
    async updateHard_Software (comp) {
      await HWSWService.updateHard_Software(comp)
    },

    getLink (url) {
      if (url !== undefined) {
        return url.includes('http') ? url : 'https://' + url
      } else {
        return ''
      }
    },

    editItem (item) {
      console.log(item)
      this.editedIndex = this.hardsoftwareitems.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    openLink (link) {
      window.open(link, '_blank')
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    async save () {
      if (this.editedIndex > -1) {
        Object.assign(this.hardsoftwareitems[this.editedIndex], this.editedItem)
        await this.updateHard_Software(this.editedItem)
        if (this.rememberUserInfo) {
          this.rememberedname = this.editedItem.name
          this.rememberedemail = this.editedItem.email
          this.rememberedinstitute = this.editedItem.institute
          this.rememberedinstituteWebsite = this.editedItem.instituteWebsite
          this.rememberedstatus = this.editedItem.status
        }
      } else {
        this.hardsoftwareitems.push(this.editedItem)
        await this.addHard_Software(this.editedItem)
        if (this.rememberUserInfo) {
          this.rememberedname = this.editedItem.name
          this.rememberedemail = this.editedItem.email
          this.rememberedinstitute = this.editedItem.institute
          this.rememberedinstituteWebsite = this.editedItem.instituteWebsite
          this.rememberedstatus = this.editedItem.status
        }
      }
      this.getHard_Software()
      this.close()
    }
  },
  mounted () {
    this.getDefaults()
    this.getHard_Software()
  }
}
</script>

<style scoped>
  .bottom-gradient {
    background-image: linear-gradient(to top,rgba(0, 0, 0, 0.2) 0%, transparent 40px);
  }
  .chip-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
  }
</style>



// WEBPACK FOOTER //
// src/components/hardsoftwareResComponent.vue